import { CommunityAlertResultDto } from './community-alert-result-dto';

export class OwnerAlertResultDto extends CommunityAlertResultDto {
    customerID: string;
}
